import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from './config';

export type CreatorFeedbackContext = 'unpublished_signup';

export async function submitCreatorFeedback(
  userId: string,
  context: CreatorFeedbackContext,
  answer: string,
  detail?: string
): Promise<void> {
  await addDoc(collection(db, 'creator_feedback'), {
    userId,
    context,
    answer,
    ...(detail ? { detail } : {}),
    createdAt: serverTimestamp(),
  });
}
